<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Add AM Allocation">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'AMAllocation' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              right
              top
            >
              <v-icon left>mdi-arrow-left</v-icon>back</v-btn
            >
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Zone
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  v-model="academicManagerObj.zoneID"
                  :items="zones"
                  item-text="name"
                  item-value="id"
                  @change="getZMByZoneId()"
                  required
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Zonal Manager Name
                  <!-- <span class="require error--text">*</span> -->
                </label>
                <v-text-field
                  class="my-0 py-1"
                  required
                  v-model="zonalManager.zmName"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Academic Manager Name
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  v-model="academicManagerObj.userID"
                  required
                  :items="amList"
                  key="id"
                  item-value="id"
                  item-text="amName"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    bottom
                    right
                    elevation="1"
                    color="primary"
                    type="submit"
                  >
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card></v-container
    >
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import _ from 'lodash'

export default {
  name: 'saveClassGroup',
  props: ['academicManagerID'],
  components: {
    MaterialCard
  },
  data () {
    return {
      id: '',
      amName: '',
      amList: [],
      zoneList: [],
      zmList: [],
      academicManagerObj: {
        zoneID: '',
        userID: ''
      },
      zonalManager: {
        zmName: []
      },
      typeArray: constants.CLASSGROUPTYPES,
      hasClicked: false,
      loader: false,
      zones: [],
      selectedZone: null,
      managers: [],
      selectedManager: null
    }
  },
  created () {
    this.getZoneList()
    this.getAMList()
  },
  methods: {
    getZoneList: async function () {
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/get/zones`)
        this.zones = data
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error while fetching zone list: ${errorMessage}`)
      }
    },
    getZMByZoneId: async function () {
      this.loader = true
      try {
        const { data } = await http.get(
          `${constants.API_URL}/api/get-zm-by-zone/${this.academicManagerObj.zoneID}`
        )
        this.managers = data
        if (data.ams_zonalManagers.length) {
          data.ams_zonalManagers.forEach((item) => {
            this.zonalManager.zmName = `${item.user.firstName} ${item.user.lastName}`
          })
        } else {
          this.zonalManager.zmName = ''
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error while fetching zonal manager list: ${errorMessage}`)
      }
    },
    getAMList: async function () {
      this.loader = true
      try {
        const { data } = await http.get(`${constants.API_URL}/api/get/user/AM`)
        this.amList = data
        this.amList = this.amList.map((item, index) => {
          item.amName = `${item.firstName ? item.firstName : '-'} ${
            item.lastName ? item.lastName : ''
          }`
          return item
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error while fetching zone list: ${errorMessage}`)
      }
    },
    save: async function () {
      this.hasClicked = true
      this.loader = true
      try {
        await http.post(
          `${constants.API_URL}/api/add/academicmanager`,
          this.academicManagerObj
        )
        this.$router.push({ name: 'AMAllocation' })
        this.okMsg('Academic manager saved successfully!')
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While allocating academic manager: ${errorMessage}`)
      }
      // }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
